/**
 * Banner types
 */
export enum BannerType {
  /**
   * Message banner - informational content
   */
  Message = 'Message',

  /**
   * Warning banner - important notices
   */
  Warning = 'Warning',

  /**
   * Critical banner - urgent/critical information
   */
  Critical = 'Critical',
}
